import { FC } from "react";
import { IpropsModalSettings } from "types/modal/TypeModal";
import OverlayModalCommon from "utils/settingsModal/common/OverLayModalCommon";
import useWindowSize from "types/other/dimensions";
import { forceUpdate } from "./forceUpdate";
const ForceUpdateModal: FC<IpropsModalSettings> = ({ onClose, open }) => {
  const viewportWidth = useWindowSize();
  const submit = () => {
    forceUpdate(true)
  };

  return (
    <>
      <OverlayModalCommon onClose={onClose} open={open}>
        <div
          className={
            viewportWidth >= 1200
              ? "contentModalSettingsMapPc scrollbar-div"
              : "contentModalSettingsMap"
          }
        >
          <div className="rowheaderModalSettingMap">
            <div onClick={onClose} className="icon3-close pointer" />
          </div>
          <div className="contentLogoutText">
            آیا مطمئن هستید که می خواهید به تنظیمات کارخانه بازگردید؟
          </div>

          <div className="rowBtnSettingsMap">
            <div onClick={submit} className="BtnSettingsMapSubmit pointer">
              بله
            </div>
            <div onClick={onClose} className="BtnSettingsMapCancel pointer">
              انصراف
            </div>
          </div>
        </div>
      </OverlayModalCommon>
    </>
  );
};
export default ForceUpdateModal;
